import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "devicon/devicon.min.css";

const container = document.getElementById("root");

if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  throw new Error("Root container missing in index.html");
}
